<template>
  <div class="col-6">
    <div class="container-stats">
      <div class="container-stats--header">
        <div class="container-state">
          <div class="container-state__title">Текущее состояние</div>
        </div>
        <p v-if="Object.keys(containerGeneralInfo).length > 0" class="container-state__updated">
          обновлено {{ containerGeneralInfo.last_message }}
        </p>
      </div>

      <h4 v-if="Object.keys(containerGeneralInfo).length === 0">Отсутствуют данные для отображения</h4>

      <div v-if="Object.keys(containerGeneralInfo).length > 0" class="row">
        <div class="col-6">
          <div
            :class="{
              'empty-container': containerGeneralInfo.state === 'READY',
              'full-container': containerGeneralInfo.state === 'FILLED',
              'infire-container': containerGeneralInfo.state === 'ALARM',
              'error-container': containerGeneralInfo.state === 'ERROR',
              'inactive-container': containerGeneralInfo.state === 'INACTIVE'
            }"
            class="container-state__image"
          ></div>
        </div>
        <div class="col-6">
          <div class="history">
            <div class="history--title">История</div>
          </div>
          <form-info
            v-for="historyElement in containerHistory"
            :key="historyElement.id"
            :title="historyElement.event_dt"
            :info="historyElement.event_repr"
          />
        </div>
      </div>

      <div v-if="chartsData[0].data.length > 0" class="row">
        <div class="col-12">
          <ContainerCharts :charts-data="chartsData" />
        </div>
      </div>

      <div v-if="Object.keys(containerGeneralInfo).length > 0" class="row">
        <div class="col-12 container-statistic">
          <div class="tko-statistic">
            <div class="tko-info">
              <div class="tko-info__content">
                <p class="header">Последний вывоз ТКО</p>
                <p class="date">{{ containerGeneralInfo.last_visit }}</p>
              </div>
            </div>
            <div class="tko-info">
              <div class="tko-info__content">
                <p class="header">Последнее наполнение ТКО</p>
                <p class="date">{{ containerGeneralInfo.last_filled }}</p>
              </div>
            </div>
          </div>
          <div class="container-average-time">
            <div class="container-average-time__content">
              <p class="header">Среднее время нахождения контейнера в заполненном состоянии</p>
              <p class="average-time">X ч/мес</p>
              <div>
                <p class="percent">Y %</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerCharts from "./ContainerCharts";
import FormInfo from "../forms/FormInfo";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "ContainerStats",
  components: {
    ContainerCharts,
    FormInfo
  },
  props: {
    containerId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      chartsData: [{ data: [] }],
      containerGeneralInfo: {},
      containerHistory: []
    };
  },
  watch: {
    containerId(newContainerId) {
      if (typeof newContainerId === "number") {
        this.$root.$emit("uploadDataValueChanging", true);

        const getContainerDataPromises = [];

        getContainerDataPromises.push(
          this.getSource({ url: `/api/containers/${this.containerId}/dashboard/filling-rate/` }).then(response => {
            if (response.data && response.data.stats) {
              const responseData = response.data.stats.values ? response.data.stats.values : [];

              this.chartsData = [{ data: responseData }];
            }
          })
        );

        getContainerDataPromises.push(
          this.getSource({ url: `/api/containers/${this.containerId}/dashboard/general/` }).then(response => {
            if (response.data) {
              if (response.data.last_message) {
                response.data.last_message = moment(response.data.last_message).format("DD.MM в h:mm");
              }
              if (response.data.last_visit) {
                response.data.last_visit = moment(response.data.last_visit).format("DD.MM.YYYY");
              }
              if (response.data.last_filled) {
                response.data.last_filled = moment(response.data.last_filled).format("DD.MM.YYYY");
              }

              this.containerGeneralInfo = response.data;
            }
          })
        );

        getContainerDataPromises.push(
          this.getSource({ url: `/api/containers/${this.containerId}/dashboard/history/` }).then(response => {
            if (response.data) {
              if (Array.isArray(response.data.history)) {
                response.data.history = response.data.history.map(elem => {
                  if (elem.event_dt) {
                    elem.event_dt = moment(elem.event_dt).format("DD.MM.YYYY h:mm");
                    return elem;
                  }
                });

                this.containerHistory = response.data.history;
              }
            }
          })
        );

        Promise.all(getContainerDataPromises).then(() => {
          this.$root.$emit("uploadDataValueChanging", false);
        });
      } else {
        this.chartsData = [{ data: [] }];
      }
    }
  },
  mounted() {
    if (typeof this.containerId === "number") {
      this.$root.$emit("uploadDataValueChanging", true);

      const getContainerDataPromises = [];

      getContainerDataPromises.push(
        this.getSource({ url: `/api/containers/${this.containerId}/dashboard/filling-rate/` }).then(response => {
          if (response.data && response.data.stats) {
            const responseData = response.data.stats.values ? response.data.stats.values : [];

            this.chartsData = [{ data: responseData }];
          }
        })
      );

      getContainerDataPromises.push(
        this.getSource({ url: `/api/containers/${this.containerId}/dashboard/general/` }).then(response => {
          if (response.data) {
            if (response.data.last_message) {
              response.data.last_message = moment(response.data.last_message).format("DD.MM в h:mm");
            }
            if (response.data.last_visit) {
              response.data.last_visit = moment(response.data.last_visit).format("DD.MM.YYYY");
            }
            if (response.data.last_filled) {
              response.data.last_filled = moment(response.data.last_filled).format("DD.MM.YYYY");
            }

            this.containerGeneralInfo = response.data;
          }
        })
      );

      getContainerDataPromises.push(
        this.getSource({ url: `/api/containers/${this.containerId}/dashboard/history/` }).then(response => {
          if (response.data) {
            if (Array.isArray(response.data.history)) {
              response.data.history = response.data.history.map(elem => {
                if (elem.event_dt) {
                  elem.event_dt = moment(elem.event_dt).format("DD.MM.YYYY h:mm");
                  return elem;
                }
              });

              this.containerHistory = response.data.history;
            }
          }
        })
      );

      Promise.all(getContainerDataPromises).then(() => {
        this.$root.$emit("uploadDataValueChanging", false);
      });
    }
  },
  methods: {
    ...mapActions(["getSource"])
  }
};
</script>
